export default async ({ $axios, store }, inject) => {

  if (process.server) return;

  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.register('/service-worker.js', {
        scope: '/'
      });
      console.log('Service Worker registered with scope:', registration.scope);
    } catch (error) {
      console.error('Service Worker registration failed:', error);
    }
  }

  const braze = await import('@braze/web-sdk');

  braze.initialize(process.env.BRAZE_API_KEY, {
    baseUrl: process.env.BRAZE_API_ENDPOINT,
    enableLogging: true,
    enableContentCards: true,
    allowUserSuppliedJavascript: true,
    serviceWorkerLocation: '/service-worker.js',
    enableSdkAuthentication: true,
    serviceWorkerScope: "/",
    disableAutomaticInAppMessages: false
  });

  // braze.openSession();

  inject('braze', braze);
};
